module.exports = __webpack_public_path__ + "img/projectNo.2328cc03.png";